export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      pricing: "Planes",
      about: "Nosotros",
      contact: "Contacto",
      login: "Iniciar Sesión",
      register: "Registrarse",
      dashboard: "Panel",
      logout: "Cerrar Sesión"
    },
    hero: {
      title: "Donde las ideas se hacen realidad",
      subtitle: "Crea aplicaciones y sitios web completamente funcionales a través de conversaciones simples",
      tabs: {
        fullstack: "App Full Stack",
        mobile: "App móvil",
        landing: "Página de aterrizaje"
      },
      placeholders: {
        fullstack: "Construyeme una plataforma de ecommerce con...",
        mobile: "Construyeme una app de seguimiento fitness...",
        landing: "Construyeme un sitio de portafolio para..."
      },
      cta: "Comenzar gratis",
      recentTasks: "Tareas recientes",
      deployedApps: "Apps desplegadas"
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Soluciones digitales que impulsan tu negocio",
      items: {
        webApps: { title: "Aplicaciones Web", desc: "Desarrollamos aplicaciones web modernas, escalables y de alto rendimiento" },
        mobileApps: { title: "Aplicaciones Móviles", desc: "Apps nativas y multiplataforma para iOS y Android" },
        websites: { title: "Páginas Web", desc: "Sitios web corporativos, comerciales y landing pages de conversión" },
        saas: { title: "Plataformas SaaS", desc: "Software como servicio con arquitectura en la nube" },
        custom: { title: "Soluciones Personalizadas", desc: "Desarrollo a medida para necesidades específicas" },
        integrations: { title: "Integraciones", desc: "Conectamos tus sistemas y automatizamos procesos" }
      }
    },
    pricing: {
      title: "Planes y Precios",
      subtitle: "Elige el plan perfecto para hacer realidad tus ideas",
      monthly: "mes",
      credits: "créditos",
      currentPlan: "Plan actual",
      subscribe: "Suscribirse",
      buyCredits: "Comprar créditos",
      essentials: {
        name: "Essentials",
        tagline: "Perfecto para constructores principiantes",
        features: [
          "Desarrollo de aplicaciones móviles",
          "Alojamiento de proyectos privados",
          "Integración con Github",
          "Fork de tareas",
          "Capacidad de comprar créditos adicionales"
        ]
      },
      plus: {
        name: "Plus",
        tagline: "Creado para creadores y marcas serias",
        features: [
          "Todo lo incluido en Essentials",
          "Agente CloudT1",
          "Ventana de contexto 1M",
          "Pensamiento ultra",
          "Editar prompt del sistema",
          "Capacidad de crear agentes personalizados"
        ]
      },
      creditPackages: {
        title: "Comprar Créditos Adicionales",
        small: "50 créditos",
        medium: "150 créditos",
        large: "400 créditos"
      }
    },
    about: {
      title: "Sobre CloudTexa",
      description: "CloudTexa es una plataforma web creada para que personas, emprendedores y empresas puedan hacer realidad sus sueños digitales.",
      purpose: { title: "Propósito", text: "Ayudar a las personas a materializar sus ideas y sueños a través de soluciones tecnológicas modernas, accesibles y confiables." },
      mission: { title: "Misión", text: "Desarrollar soluciones digitales innovadoras que impulsen el crecimiento de personas y negocios." },
      vision: { title: "Visión", text: "Ser una plataforma tecnológica de referencia en el desarrollo de soluciones digitales en la nube." },
      values: {
        title: "Valores",
        innovation: "Innovación constante",
        commitment: "Compromiso con el cliente",
        trust: "Confianza y seguridad",
        creativity: "Creatividad tecnológica",
        scalability: "Escalabilidad y futuro digital"
      }
    },
    contact: {
      title: "Contáctanos",
      subtitle: "Estamos aquí para ayudarte a hacer realidad tu proyecto",
      form: {
        name: "Nombre",
        email: "Email",
        subject: "Asunto",
        message: "Mensaje",
        send: "Enviar mensaje"
      },
      success: "Mensaje enviado correctamente",
      error: "Error al enviar el mensaje"
    },
    footer: {
      slogan: "Tecnología que impulsa tus ideas",
      rights: "Todos los derechos reservados"
    },
    auth: {
      loginTitle: "Iniciar Sesión",
      registerTitle: "Crear Cuenta",
      email: "Email",
      password: "Contraseña",
      name: "Nombre completo",
      loginButton: "Iniciar Sesión",
      registerButton: "Registrarse",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      createAccount: "Crear cuenta",
      loginHere: "Inicia sesión aquí",
      referralCode: "Código de referido (opcional)",
      referralPlaceholder: "Ej: JUAN1234"
    },
    dashboard: {
      welcome: "Bienvenido",
      credits: "Créditos disponibles",
      plan: "Plan",
      projects: "Mis Proyectos",
      newProject: "Nuevo Proyecto",
      recentTasks: "Tareas Recientes",
      noProjects: "No tienes proyectos aún",
      createFirst: "Crea tu primer proyecto"
    },
    referral: {
      title: "Invita amigos y gana créditos",
      subtitle: "Comparte tu código y ambos ganan",
      yourCode: "Tu código de referido",
      copied: "¡Copiado!",
      copyCode: "Copiar código",
      shareLink: "Compartir enlace",
      stats: "Estadísticas de referidos",
      friendsReferred: "Amigos referidos",
      creditsEarned: "Créditos ganados",
      youGet: "Tú recibes",
      friendGets: "Tu amigo recibe",
      howItWorks: "¿Cómo funciona?",
      step1: "Comparte tu código con amigos",
      step2: "Tu amigo se registra con tu código",
      step3: "¡Ambos reciben créditos gratis!"
    },
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      cancel: "Cancelar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Crear",
      public: "Público"
    }
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      pricing: "Pricing",
      about: "About",
      contact: "Contact",
      login: "Login",
      register: "Register",
      dashboard: "Dashboard",
      logout: "Logout"
    },
    hero: {
      title: "Where ideas become reality",
      subtitle: "Create fully functional applications and websites through simple conversations",
      tabs: {
        fullstack: "Full Stack App",
        mobile: "Mobile App",
        landing: "Landing Page"
      },
      placeholders: {
        fullstack: "Build me an ecommerce platform with...",
        mobile: "Build me a fitness tracking app...",
        landing: "Build me a portfolio site for..."
      },
      cta: "Start for free",
      recentTasks: "Recent tasks",
      deployedApps: "Deployed apps"
    },
    services: {
      title: "Our Services",
      subtitle: "Digital solutions that drive your business",
      items: {
        webApps: { title: "Web Applications", desc: "We develop modern, scalable and high-performance web applications" },
        mobileApps: { title: "Mobile Applications", desc: "Native and cross-platform apps for iOS and Android" },
        websites: { title: "Websites", desc: "Corporate websites, commercial sites and conversion landing pages" },
        saas: { title: "SaaS Platforms", desc: "Software as a service with cloud architecture" },
        custom: { title: "Custom Solutions", desc: "Tailor-made development for specific needs" },
        integrations: { title: "Integrations", desc: "We connect your systems and automate processes" }
      }
    },
    pricing: {
      title: "Plans & Pricing",
      subtitle: "Choose the perfect plan to make your ideas come true",
      monthly: "month",
      credits: "credits",
      currentPlan: "Current plan",
      subscribe: "Subscribe",
      buyCredits: "Buy credits",
      essentials: {
        name: "Essentials",
        tagline: "Perfect for beginner builders",
        features: [
          "Mobile application development",
          "Private project hosting",
          "Github integration",
          "Task forking",
          "Ability to buy additional credits"
        ]
      },
      plus: {
        name: "Plus",
        tagline: "Built for serious creators and brands",
        features: [
          "Everything in Essentials",
          "CloudT1 Agent",
          "1M context window",
          "Ultra thinking",
          "Edit system prompt",
          "Ability to create custom agents"
        ]
      },
      creditPackages: {
        title: "Buy Additional Credits",
        small: "50 credits",
        medium: "150 credits",
        large: "400 credits"
      }
    },
    about: {
      title: "About CloudTexa",
      description: "CloudTexa is a web platform created so that people, entrepreneurs and companies can make their digital dreams come true.",
      purpose: { title: "Purpose", text: "Help people materialize their ideas and dreams through modern, accessible and reliable technological solutions." },
      mission: { title: "Mission", text: "Develop innovative digital solutions that drive the growth of people and businesses." },
      vision: { title: "Vision", text: "Be a leading technology platform in the development of cloud digital solutions." },
      values: {
        title: "Values",
        innovation: "Constant innovation",
        commitment: "Customer commitment",
        trust: "Trust and security",
        creativity: "Technological creativity",
        scalability: "Scalability and digital future"
      }
    },
    contact: {
      title: "Contact Us",
      subtitle: "We are here to help you make your project a reality",
      form: {
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        send: "Send message"
      },
      success: "Message sent successfully",
      error: "Error sending message"
    },
    footer: {
      slogan: "Technology that drives your ideas",
      rights: "All rights reserved"
    },
    auth: {
      loginTitle: "Login",
      registerTitle: "Create Account",
      email: "Email",
      password: "Password",
      name: "Full name",
      loginButton: "Login",
      registerButton: "Register",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      createAccount: "Create account",
      loginHere: "Login here",
      referralCode: "Referral code (optional)",
      referralPlaceholder: "Ex: JOHN1234"
    },
    dashboard: {
      welcome: "Welcome",
      credits: "Available credits",
      plan: "Plan",
      projects: "My Projects",
      newProject: "New Project",
      recentTasks: "Recent Tasks",
      noProjects: "You have no projects yet",
      createFirst: "Create your first project"
    },
    referral: {
      title: "Invite friends and earn credits",
      subtitle: "Share your code and both win",
      yourCode: "Your referral code",
      copied: "Copied!",
      copyCode: "Copy code",
      shareLink: "Share link",
      stats: "Referral statistics",
      friendsReferred: "Friends referred",
      creditsEarned: "Credits earned",
      youGet: "You get",
      friendGets: "Your friend gets",
      howItWorks: "How it works?",
      step1: "Share your code with friends",
      step2: "Your friend signs up with your code",
      step3: "Both get free credits!"
    },
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      public: "Public"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      pricing: "Tarifs",
      about: "À propos",
      contact: "Contact",
      login: "Connexion",
      register: "S'inscrire",
      dashboard: "Tableau de bord",
      logout: "Déconnexion"
    },
    hero: {
      title: "Où les idées deviennent réalité",
      subtitle: "Créez des applications et des sites web entièrement fonctionnels grâce à de simples conversations",
      tabs: {
        fullstack: "App Full Stack",
        mobile: "App Mobile",
        landing: "Page d'atterrissage"
      },
      placeholders: {
        fullstack: "Construisez-moi une plateforme e-commerce avec...",
        mobile: "Construisez-moi une app de suivi fitness...",
        landing: "Construisez-moi un site portfolio pour..."
      },
      cta: "Commencer gratuitement",
      recentTasks: "Tâches récentes",
      deployedApps: "Apps déployées"
    },
    services: {
      title: "Nos Services",
      subtitle: "Des solutions numériques qui propulsent votre entreprise",
      items: {
        webApps: { title: "Applications Web", desc: "Nous développons des applications web modernes, évolutives et performantes" },
        mobileApps: { title: "Applications Mobiles", desc: "Apps natives et multiplateformes pour iOS et Android" },
        websites: { title: "Sites Web", desc: "Sites web corporatifs, commerciaux et pages de conversion" },
        saas: { title: "Plateformes SaaS", desc: "Logiciel en tant que service avec architecture cloud" },
        custom: { title: "Solutions Personnalisées", desc: "Développement sur mesure pour des besoins spécifiques" },
        integrations: { title: "Intégrations", desc: "Nous connectons vos systèmes et automatisons les processus" }
      }
    },
    pricing: {
      title: "Plans et Tarifs",
      subtitle: "Choisissez le plan parfait pour réaliser vos idées",
      monthly: "mois",
      credits: "crédits",
      currentPlan: "Plan actuel",
      subscribe: "S'abonner",
      buyCredits: "Acheter des crédits",
      essentials: {
        name: "Essentials",
        tagline: "Parfait pour les débutants",
        features: [
          "Développement d'applications mobiles",
          "Hébergement de projets privés",
          "Intégration Github",
          "Fork de tâches",
          "Possibilité d'acheter des crédits supplémentaires"
        ]
      },
      plus: {
        name: "Plus",
        tagline: "Conçu pour les créateurs sérieux",
        features: [
          "Tout inclus dans Essentials",
          "Agent CloudT1",
          "Fenêtre de contexte 1M",
          "Pensée ultra",
          "Modifier le prompt système",
          "Créer des agents personnalisés"
        ]
      },
      creditPackages: {
        title: "Acheter des Crédits Supplémentaires",
        small: "50 crédits",
        medium: "150 crédits",
        large: "400 crédits"
      }
    },
    about: {
      title: "À propos de CloudTexa",
      description: "CloudTexa est une plateforme web créée pour que les personnes, entrepreneurs et entreprises puissent réaliser leurs rêves numériques.",
      purpose: { title: "But", text: "Aider les gens à matérialiser leurs idées grâce à des solutions technologiques modernes et fiables." },
      mission: { title: "Mission", text: "Développer des solutions numériques innovantes qui stimulent la croissance." },
      vision: { title: "Vision", text: "Être une plateforme technologique de référence dans le développement de solutions cloud." },
      values: {
        title: "Valeurs",
        innovation: "Innovation constante",
        commitment: "Engagement client",
        trust: "Confiance et sécurité",
        creativity: "Créativité technologique",
        scalability: "Évolutivité et avenir numérique"
      }
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour vous aider à réaliser votre projet",
      form: {
        name: "Nom",
        email: "Email",
        subject: "Sujet",
        message: "Message",
        send: "Envoyer"
      },
      success: "Message envoyé avec succès",
      error: "Erreur lors de l'envoi"
    },
    footer: {
      slogan: "La technologie qui propulse vos idées",
      rights: "Tous droits réservés"
    },
    auth: {
      loginTitle: "Connexion",
      registerTitle: "Créer un compte",
      email: "Email",
      password: "Mot de passe",
      name: "Nom complet",
      loginButton: "Se connecter",
      registerButton: "S'inscrire",
      noAccount: "Pas de compte?",
      hasAccount: "Déjà un compte?",
      createAccount: "Créer un compte",
      loginHere: "Connectez-vous ici"
    },
    dashboard: {
      welcome: "Bienvenue",
      credits: "Crédits disponibles",
      plan: "Plan",
      projects: "Mes Projets",
      newProject: "Nouveau Projet",
      recentTasks: "Tâches Récentes",
      noProjects: "Vous n'avez pas encore de projets",
      createFirst: "Créez votre premier projet"
    },
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      cancel: "Annuler",
      save: "Sauvegarder",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Créer",
      public: "Public"
    }
  },
  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      pricing: "Prezzi",
      about: "Chi siamo",
      contact: "Contatti",
      login: "Accedi",
      register: "Registrati",
      dashboard: "Dashboard",
      logout: "Esci"
    },
    hero: {
      title: "Dove le idee diventano realtà",
      subtitle: "Crea applicazioni e siti web completamente funzionali attraverso semplici conversazioni",
      tabs: {
        fullstack: "App Full Stack",
        mobile: "App Mobile",
        landing: "Landing Page"
      },
      placeholders: {
        fullstack: "Costruiscimi una piattaforma ecommerce con...",
        mobile: "Costruiscimi un'app di fitness tracking...",
        landing: "Costruiscimi un sito portfolio per..."
      },
      cta: "Inizia gratis",
      recentTasks: "Attività recenti",
      deployedApps: "App distribuite"
    },
    services: {
      title: "I Nostri Servizi",
      subtitle: "Soluzioni digitali che guidano il tuo business",
      items: {
        webApps: { title: "Applicazioni Web", desc: "Sviluppiamo applicazioni web moderne, scalabili e ad alte prestazioni" },
        mobileApps: { title: "Applicazioni Mobile", desc: "App native e multipiattaforma per iOS e Android" },
        websites: { title: "Siti Web", desc: "Siti web aziendali, commerciali e landing page di conversione" },
        saas: { title: "Piattaforme SaaS", desc: "Software as a service con architettura cloud" },
        custom: { title: "Soluzioni Personalizzate", desc: "Sviluppo su misura per esigenze specifiche" },
        integrations: { title: "Integrazioni", desc: "Colleghiamo i tuoi sistemi e automatizziamo i processi" }
      }
    },
    pricing: {
      title: "Piani e Prezzi",
      subtitle: "Scegli il piano perfetto per realizzare le tue idee",
      monthly: "mese",
      credits: "crediti",
      currentPlan: "Piano attuale",
      subscribe: "Abbonati",
      buyCredits: "Acquista crediti",
      essentials: {
        name: "Essentials",
        tagline: "Perfetto per costruttori principianti",
        features: [
          "Sviluppo applicazioni mobile",
          "Hosting progetti privati",
          "Integrazione Github",
          "Fork delle attività",
          "Possibilità di acquistare crediti aggiuntivi"
        ]
      },
      plus: {
        name: "Plus",
        tagline: "Creato per creatori seri",
        features: [
          "Tutto incluso in Essentials",
          "Agente CloudT1",
          "Finestra di contesto 1M",
          "Pensiero ultra",
          "Modifica prompt di sistema",
          "Creazione agenti personalizzati"
        ]
      },
      creditPackages: {
        title: "Acquista Crediti Aggiuntivi",
        small: "50 crediti",
        medium: "150 crediti",
        large: "400 crediti"
      }
    },
    about: {
      title: "Chi è CloudTexa",
      description: "CloudTexa è una piattaforma web creata affinché persone, imprenditori e aziende possano realizzare i loro sogni digitali.",
      purpose: { title: "Scopo", text: "Aiutare le persone a materializzare le loro idee attraverso soluzioni tecnologiche moderne e affidabili." },
      mission: { title: "Missione", text: "Sviluppare soluzioni digitali innovative che stimolino la crescita." },
      vision: { title: "Visione", text: "Essere una piattaforma tecnologica di riferimento nello sviluppo di soluzioni cloud." },
      values: {
        title: "Valori",
        innovation: "Innovazione costante",
        commitment: "Impegno verso il cliente",
        trust: "Fiducia e sicurezza",
        creativity: "Creatività tecnologica",
        scalability: "Scalabilità e futuro digitale"
      }
    },
    contact: {
      title: "Contattaci",
      subtitle: "Siamo qui per aiutarti a realizzare il tuo progetto",
      form: {
        name: "Nome",
        email: "Email",
        subject: "Oggetto",
        message: "Messaggio",
        send: "Invia messaggio"
      },
      success: "Messaggio inviato con successo",
      error: "Errore nell'invio del messaggio"
    },
    footer: {
      slogan: "Tecnologia che guida le tue idee",
      rights: "Tutti i diritti riservati"
    },
    auth: {
      loginTitle: "Accedi",
      registerTitle: "Crea Account",
      email: "Email",
      password: "Password",
      name: "Nome completo",
      loginButton: "Accedi",
      registerButton: "Registrati",
      noAccount: "Non hai un account?",
      hasAccount: "Hai già un account?",
      createAccount: "Crea account",
      loginHere: "Accedi qui"
    },
    dashboard: {
      welcome: "Benvenuto",
      credits: "Crediti disponibili",
      plan: "Piano",
      projects: "I Miei Progetti",
      newProject: "Nuovo Progetto",
      recentTasks: "Attività Recenti",
      noProjects: "Non hai ancora progetti",
      createFirst: "Crea il tuo primo progetto"
    },
    common: {
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      cancel: "Annulla",
      save: "Salva",
      delete: "Elimina",
      edit: "Modifica",
      create: "Crea",
      public: "Pubblico"
    }
  },
  "pt-BR": {
    nav: {
      home: "Início",
      services: "Serviços",
      pricing: "Preços",
      about: "Sobre",
      contact: "Contato",
      login: "Entrar",
      register: "Cadastrar",
      dashboard: "Painel",
      logout: "Sair"
    },
    hero: {
      title: "Onde as ideias se tornam realidade",
      subtitle: "Crie aplicativos e sites totalmente funcionais através de conversas simples",
      tabs: {
        fullstack: "App Full Stack",
        mobile: "App Móvel",
        landing: "Landing Page"
      },
      placeholders: {
        fullstack: "Construa para mim uma plataforma de ecommerce com...",
        mobile: "Construa para mim um app de fitness tracking...",
        landing: "Construa para mim um site de portfólio para..."
      },
      cta: "Começar grátis",
      recentTasks: "Tarefas recentes",
      deployedApps: "Apps implantados"
    },
    services: {
      title: "Nossos Serviços",
      subtitle: "Soluções digitais que impulsionam seu negócio",
      items: {
        webApps: { title: "Aplicações Web", desc: "Desenvolvemos aplicações web modernas, escaláveis e de alto desempenho" },
        mobileApps: { title: "Aplicações Móveis", desc: "Apps nativos e multiplataforma para iOS e Android" },
        websites: { title: "Sites", desc: "Sites corporativos, comerciais e landing pages de conversão" },
        saas: { title: "Plataformas SaaS", desc: "Software como serviço com arquitetura em nuvem" },
        custom: { title: "Soluções Personalizadas", desc: "Desenvolvimento sob medida para necessidades específicas" },
        integrations: { title: "Integrações", desc: "Conectamos seus sistemas e automatizamos processos" }
      }
    },
    pricing: {
      title: "Planos e Preços",
      subtitle: "Escolha o plano perfeito para realizar suas ideias",
      monthly: "mês",
      credits: "créditos",
      currentPlan: "Plano atual",
      subscribe: "Assinar",
      buyCredits: "Comprar créditos",
      essentials: {
        name: "Essentials",
        tagline: "Perfeito para iniciantes",
        features: [
          "Desenvolvimento de apps móveis",
          "Hospedagem de projetos privados",
          "Integração com Github",
          "Fork de tarefas",
          "Possibilidade de comprar créditos adicionais"
        ]
      },
      plus: {
        name: "Plus",
        tagline: "Feito para criadores sérios",
        features: [
          "Tudo incluído no Essentials",
          "Agente CloudT1",
          "Janela de contexto 1M",
          "Pensamento ultra",
          "Editar prompt do sistema",
          "Criar agentes personalizados"
        ]
      },
      creditPackages: {
        title: "Comprar Créditos Adicionais",
        small: "50 créditos",
        medium: "150 créditos",
        large: "400 créditos"
      }
    },
    about: {
      title: "Sobre a CloudTexa",
      description: "CloudTexa é uma plataforma web criada para que pessoas, empreendedores e empresas possam realizar seus sonhos digitais.",
      purpose: { title: "Propósito", text: "Ajudar as pessoas a materializar suas ideias através de soluções tecnológicas modernas e confiáveis." },
      mission: { title: "Missão", text: "Desenvolver soluções digitais inovadoras que impulsionem o crescimento." },
      vision: { title: "Visão", text: "Ser uma plataforma tecnológica de referência no desenvolvimento de soluções em nuvem." },
      values: {
        title: "Valores",
        innovation: "Inovação constante",
        commitment: "Compromisso com o cliente",
        trust: "Confiança e segurança",
        creativity: "Criatividade tecnológica",
        scalability: "Escalabilidade e futuro digital"
      }
    },
    contact: {
      title: "Contate-nos",
      subtitle: "Estamos aqui para ajudá-lo a realizar seu projeto",
      form: {
        name: "Nome",
        email: "Email",
        subject: "Assunto",
        message: "Mensagem",
        send: "Enviar mensagem"
      },
      success: "Mensagem enviada com sucesso",
      error: "Erro ao enviar mensagem"
    },
    footer: {
      slogan: "Tecnologia que impulsiona suas ideias",
      rights: "Todos os direitos reservados"
    },
    auth: {
      loginTitle: "Entrar",
      registerTitle: "Criar Conta",
      email: "Email",
      password: "Senha",
      name: "Nome completo",
      loginButton: "Entrar",
      registerButton: "Cadastrar",
      noAccount: "Não tem uma conta?",
      hasAccount: "Já tem uma conta?",
      createAccount: "Criar conta",
      loginHere: "Entre aqui"
    },
    dashboard: {
      welcome: "Bem-vindo",
      credits: "Créditos disponíveis",
      plan: "Plano",
      projects: "Meus Projetos",
      newProject: "Novo Projeto",
      recentTasks: "Tarefas Recentes",
      noProjects: "Você ainda não tem projetos",
      createFirst: "Crie seu primeiro projeto"
    },
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      cancel: "Cancelar",
      save: "Salvar",
      delete: "Excluir",
      edit: "Editar",
      create: "Criar",
      public: "Público"
    }
  },
  "pt-PT": {
    nav: {
      home: "Início",
      services: "Serviços",
      pricing: "Preços",
      about: "Sobre",
      contact: "Contacto",
      login: "Entrar",
      register: "Registar",
      dashboard: "Painel",
      logout: "Sair"
    },
    hero: {
      title: "Onde as ideias se tornam realidade",
      subtitle: "Crie aplicações e websites totalmente funcionais através de conversas simples",
      tabs: {
        fullstack: "App Full Stack",
        mobile: "App Móvel",
        landing: "Landing Page"
      },
      placeholders: {
        fullstack: "Construa-me uma plataforma de ecommerce com...",
        mobile: "Construa-me uma app de fitness tracking...",
        landing: "Construa-me um site de portfólio para..."
      },
      cta: "Começar grátis",
      recentTasks: "Tarefas recentes",
      deployedApps: "Apps implementadas"
    },
    services: {
      title: "Os Nossos Serviços",
      subtitle: "Soluções digitais que impulsionam o seu negócio",
      items: {
        webApps: { title: "Aplicações Web", desc: "Desenvolvemos aplicações web modernas, escaláveis e de alto desempenho" },
        mobileApps: { title: "Aplicações Móveis", desc: "Apps nativas e multiplataforma para iOS e Android" },
        websites: { title: "Websites", desc: "Websites corporativos, comerciais e landing pages de conversão" },
        saas: { title: "Plataformas SaaS", desc: "Software como serviço com arquitectura na nuvem" },
        custom: { title: "Soluções Personalizadas", desc: "Desenvolvimento à medida para necessidades específicas" },
        integrations: { title: "Integrações", desc: "Conectamos os seus sistemas e automatizamos processos" }
      }
    },
    pricing: {
      title: "Planos e Preços",
      subtitle: "Escolha o plano perfeito para realizar as suas ideias",
      monthly: "mês",
      credits: "créditos",
      currentPlan: "Plano atual",
      subscribe: "Subscrever",
      buyCredits: "Comprar créditos",
      essentials: {
        name: "Essentials",
        tagline: "Perfeito para iniciantes",
        features: [
          "Desenvolvimento de apps móveis",
          "Alojamento de projectos privados",
          "Integração com Github",
          "Fork de tarefas",
          "Possibilidade de comprar créditos adicionais"
        ]
      },
      plus: {
        name: "Plus",
        tagline: "Feito para criadores sérios",
        features: [
          "Tudo incluído no Essentials",
          "Agente CloudT1",
          "Janela de contexto 1M",
          "Pensamento ultra",
          "Editar prompt do sistema",
          "Criar agentes personalizados"
        ]
      },
      creditPackages: {
        title: "Comprar Créditos Adicionais",
        small: "50 créditos",
        medium: "150 créditos",
        large: "400 créditos"
      }
    },
    about: {
      title: "Sobre a CloudTexa",
      description: "CloudTexa é uma plataforma web criada para que pessoas, empreendedores e empresas possam realizar os seus sonhos digitais.",
      purpose: { title: "Propósito", text: "Ajudar as pessoas a materializar as suas ideias através de soluções tecnológicas modernas e fiáveis." },
      mission: { title: "Missão", text: "Desenvolver soluções digitais inovadoras que impulsionem o crescimento." },
      vision: { title: "Visão", text: "Ser uma plataforma tecnológica de referência no desenvolvimento de soluções na nuvem." },
      values: {
        title: "Valores",
        innovation: "Inovação constante",
        commitment: "Compromisso com o cliente",
        trust: "Confiança e segurança",
        creativity: "Criatividade tecnológica",
        scalability: "Escalabilidade e futuro digital"
      }
    },
    contact: {
      title: "Contacte-nos",
      subtitle: "Estamos aqui para ajudá-lo a realizar o seu projecto",
      form: {
        name: "Nome",
        email: "Email",
        subject: "Assunto",
        message: "Mensagem",
        send: "Enviar mensagem"
      },
      success: "Mensagem enviada com sucesso",
      error: "Erro ao enviar mensagem"
    },
    footer: {
      slogan: "Tecnologia que impulsiona as suas ideias",
      rights: "Todos os direitos reservados"
    },
    auth: {
      loginTitle: "Entrar",
      registerTitle: "Criar Conta",
      email: "Email",
      password: "Palavra-passe",
      name: "Nome completo",
      loginButton: "Entrar",
      registerButton: "Registar",
      noAccount: "Não tem uma conta?",
      hasAccount: "Já tem uma conta?",
      createAccount: "Criar conta",
      loginHere: "Entre aqui"
    },
    dashboard: {
      welcome: "Bem-vindo",
      credits: "Créditos disponíveis",
      plan: "Plano",
      projects: "Os Meus Projectos",
      newProject: "Novo Projecto",
      recentTasks: "Tarefas Recentes",
      noProjects: "Ainda não tem projectos",
      createFirst: "Crie o seu primeiro projecto"
    },
    common: {
      loading: "A carregar...",
      error: "Erro",
      success: "Sucesso",
      cancel: "Cancelar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Criar",
      public: "Público"
    }
  }
};

export const languages = [
  { code: "es", name: "Español", flag: "ES" },
  { code: "en", name: "English", flag: "US" },
  { code: "fr", name: "Français", flag: "FR" },
  { code: "it", name: "Italiano", flag: "IT" },
  { code: "pt-BR", name: "Português (Brazil)", flag: "BR" },
  { code: "pt-PT", name: "Português (Portugal)", flag: "PT" }
];
